import { Dialog } from '@economic/taco';
import React from 'react';
import { t } from '../../shared/components/l10n/l10n';

import ConfirmationDialog from '../../shared/components/modals/ConfirmationDialog';
import { useDisableKeyShortcuts } from '../../shared/hooks/useKeyShortcut';

interface DeleteProductGroupDialogProps {
    onClose: () => void;
    productGroupName?: string;
    onConfirm: () => Promise<void>;
}

const DeleteProductGroupDialog = ({ productGroupName, onClose, onConfirm }: DeleteProductGroupDialogProps) => {
    useDisableKeyShortcuts();

    return (
        <Dialog size="xs" onClose={onClose} defaultOpen>
            <Dialog.Content aria-label={t`DIALOG_DELETE_PRODUCT_GROUP`}>
                {({ close }) => (
                    <ConfirmationDialog
                        confirmText={t`BUTTON_DELETE`}
                        label={t`FIREBIRD_POPUP_TITLE_PLEASE_CONFIRM`}
                        message={t('FORM_DELETEMESSAGE', { FIELDNAME: productGroupName })}
                        onCancel={() => {
                            close();
                            onClose();
                        }}
                        onConfirm={onConfirm}
                        focusConfirmButton
                    />
                )}
            </Dialog.Content>
        </Dialog>
    );
};

export default DeleteProductGroupDialog;
